import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { AlertTriangle, Clock } from 'lucide-react';

const SessionTimeoutModal = () => {
  const { sessionTimeoutWarning, extendSession, logout } = useAuth();
  const [countdown, setCountdown] = useState(120); // 2 minutes countdown

  useEffect(() => {
    let timer;
    if (sessionTimeoutWarning) {
      setCountdown(120); // Reset countdown when modal appears
      
      timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            logout(); // Auto logout when countdown reaches 0
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [sessionTimeoutWarning, logout]);

  if (!sessionTimeoutWarning) {
    return null;
  }

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <Dialog open={sessionTimeoutWarning} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-orange-600">
            <AlertTriangle className="w-5 h-5" />
            Session Timeout Warning
          </DialogTitle>
          <DialogDescription>
            Your session will expire soon due to inactivity.
          </DialogDescription>
        </DialogHeader>
        
        <div className="text-center py-6">
          <Clock className="w-12 h-12 text-orange-500 mx-auto mb-4" />
          <p className="text-lg font-semibold text-gray-900 mb-2">
            Session expires in:
          </p>
          <div className="text-3xl font-bold text-orange-600 mb-4">
            {formatTime(countdown)}
          </div>
          <p className="text-sm text-gray-600">
            Click &quot;Stay Logged In&quot; to extend your session, or you will be automatically logged out for security.
          </p>
        </div>

        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={logout}
            className="flex-1"
          >
            Logout Now
          </Button>
          <Button
            onClick={extendSession}
            className="flex-1 bg-blue-600 hover:bg-blue-700"
          >
            Stay Logged In
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SessionTimeoutModal;